module.exports = __webpack_public_path__ + "img/user-large-slash.18ccb7fd.svg";